const MAX_STACK_SIZE = 10;

const read = (key: string): string[] => {
  try {
    const raw = sessionStorage.getItem(key);
    return JSON.parse(raw || '[]');
  } catch {
    return [];
  }
};

const write = (key: string, stack: string[]): void => {
  sessionStorage.setItem(key, JSON.stringify(stack));
};

const clear = (key: string) => write(key, []);

const peek = (key: string): string | undefined => {
  const stack = read(key);
  return stack[stack.length - 1];
};

const pop = (key: string): string | undefined => {
  const stack = read(key);
  const target = stack.pop();
  write(key, stack);

  return target;
};

const push = (key: string, path: string) => {
  const stack = read(key);

  if (peek(key) === path) return;

  stack.push(path);

  if (stack.length > MAX_STACK_SIZE) stack.shift();

  write(key, stack);
};

const jumpToIndex = (key: string, _index: number): string | undefined => {
  const stack = read(key);

  const index = _index < 0 ? stack.length + _index : _index;
  if (index !== -1) {
    write(key, stack.slice(0, index + 1));
    return stack[index];
  }

  return undefined;
};

const jumpToPath = (key: string, path: string): string | undefined => {
  const stack = read(key);
  const index = stack.lastIndexOf(path);

  if (index !== -1) {
    write(key, stack.slice(0, index + 1));
    return stack[index];
  }

  return undefined;
};

const removeParams = (key: string, params: string[]) => {
  const stack = read(key);
  const filteredStack = stack?.filter((path) => (
    params.every((param) => !path.includes(param))
  ));

  if (filteredStack?.length !== stack?.length) {
    write(key, filteredStack);
  }
};

const removePath = (key: string, path: string) => {
  const stack = read(key);
  const filteredStack = stack?.filter((p) => p !== path);

  if (filteredStack?.length !== stack?.length) {
    write(key, filteredStack);
  }
};

export const historyStorage = {
  read,
  write,
  clear,
  peek,
  pop,
  push,
  jumpToIndex,
  jumpToPath,
  removeParams,
  removePath,
} as const;
